import { render } from "./DocumentReportAutovalidation.vue?vue&type=template&id=75089cb1&scoped=true&ts=true"
import script from "./DocumentReportAutovalidation.vue?vue&type=script&lang=ts"
export * from "./DocumentReportAutovalidation.vue?vue&type=script&lang=ts"

import "./DocumentReportAutovalidation.vue?vue&type=style&index=0&id=75089cb1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75089cb1"]])

export default __exports__